import { LISTAR_URAS, LISTAR_URA_SELECIONADA, GET_URA_USE, LISTAR_ROTAS, LISTAR_AUDIOS, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

export default {
  [LISTAR_URAS]: (state, uras) => {
    state.uras = uras
  },
  [LISTAR_URA_SELECIONADA]: (state, ura) => {
    state.uraSelecionada = ura
  },
  [GET_URA_USE]: (state, uraUse) => {
    state.uraUse = uraUse
  },
  [LISTAR_ROTAS]: (state, rotas) => {
    state.rotasDisponiveis = rotas
  },
  [LISTAR_AUDIOS]: (state, audios) => {
    state.audios = audios
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  },
}
